import { FormControlsComponent } from './form-controls/form-controls.component';
import { SendEmailFormComponent } from './send-email-form/send-email-form.component';

export const FORMS_COMPONENTS = [FormControlsComponent, SendEmailFormComponent];
